import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HelmetProvider } from 'react-helmet-async';
import { createRoot } from 'react-dom/client';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { QuoteFlowProvider } from './contexts/QuoteFlowContext';
import './index.css';
import './analytics';
import { UI_THEME } from './config/uiTheme';

document.documentElement.dataset.uiTheme = UI_THEME;

const queryClient = new QueryClient();

createRoot(document.getElementById('root')!).render(
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <QuoteFlowProvider>
          <App />
        </QuoteFlowProvider>
      </AuthProvider>
    </QueryClientProvider>
  </HelmetProvider>,
);
